var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 60 60",
    viewBox: "0 0 60 60",
    id: "linkedin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Captions",
    fill: "#fff",
    d: "M50,60H10C4.477,60,0,55.523,0,50V10C0,4.477,4.477,0,10,0h40c5.523,0,10,4.477,10,10v40 C60,55.523,55.523,60,50,60z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#78a0f0",
    d: "M30,53.5c-4.913,0-9.895-0.456-14.808-1.354c-3.769-0.689-6.649-3.569-7.338-7.338 C6.956,39.895,6.5,34.913,6.5,30s0.456-9.895,1.354-14.808c0.689-3.769,3.569-6.649,7.338-7.338 c7.999-1.462,16.107-1.739,24.115-0.819c0.548,0.063,0.942,0.559,0.879,1.108s-0.562,0.942-1.108,0.879 c-7.812-0.896-15.72-0.628-23.527,0.799c-2.943,0.538-5.192,2.787-5.73,5.73C8.944,20.346,8.5,25.207,8.5,30 s0.444,9.654,1.321,14.449c0.538,2.943,2.787,5.192,5.73,5.73c9.589,1.754,19.308,1.754,28.897,0 c2.943-0.538,5.192-2.787,5.73-5.73C51.056,39.654,51.5,34.793,51.5,30s-0.444-9.654-1.321-14.449 c-0.538-2.943-2.787-5.192-5.73-5.73c-0.485-0.089-0.971-0.173-1.456-0.253c-0.545-0.089-0.915-0.604-0.825-1.148 c0.088-0.545,0.6-0.915,1.148-0.825c0.498,0.082,0.995,0.168,1.492,0.259c3.769,0.689,6.649,3.569,7.338,7.338 C53.044,20.105,53.5,25.087,53.5,30s-0.456,9.895-1.354,14.808c-0.689,3.769-3.569,6.649-7.338,7.338 C39.895,53.044,34.913,53.5,30,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#acedf6",
    d: "M30,49.5c-4.673,0-9.413-0.434-14.089-1.289c-2.117-0.387-3.735-2.005-4.123-4.123 c-1.709-9.349-1.709-18.829,0-28.178c0.387-2.117,2.005-3.735,4.123-4.123C20.587,10.934,25.327,10.5,30,10.5 s9.413,0.434,14.089,1.289c2.117,0.387,3.735,2.005,4.123,4.123c1.709,9.349,1.709,18.829,0,28.178 c-0.387,2.117-2.005,3.735-4.123,4.123C39.413,49.066,34.673,49.5,30,49.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 20,
    x: 16,
    y: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78a0f0",
    d: "M22,45h-6c-0.552,0-1-0.448-1-1V24c0-0.552,0.448-1,1-1h6c0.552,0,1,0.448,1,1v20 C23,44.552,22.552,45,22,45z M17,43h4V25h-4V43z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37,24c-1.96,0-3.729,0.808-5,2.106V24h-6v20h6V33c0-1.657,1.343-3,3-3s3,1.343,3,3v11h6V31 C44,27.134,40.866,24,37,24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78a0f0",
    d: "M44,45h-6c-0.552,0-1-0.448-1-1V33c0-1.103-0.897-2-2-2s-2,0.897-2,2v11c0,0.552-0.448,1-1,1h-6 c-0.552,0-1-0.448-1-1V24c0-0.552,0.448-1,1-1h6c0.552,0,1,0.448,1,1v0.07c1.202-0.698,2.571-1.07,4-1.07c4.411,0,8,3.589,8,8 v13C45,44.552,44.552,45,44,45z M39,43h4V31c0-3.309-2.691-6-6-6c-1.624,0-3.146,0.641-4.286,1.805 c-0.284,0.29-0.718,0.379-1.092,0.226C31.246,26.878,31,26.512,31,26.105V25h-4v18h4V33c0-2.206,1.794-4,4-4s4,1.794,4,4V43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78a0f0",
    d: "M19,21c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S21.206,21,19,21z M19,15c-1.103,0-2,0.897-2,2 s0.897,2,2,2s2-0.897,2-2S20.103,15,19,15z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.61be6cffdd70dfd883e27a98fdd64bb3.svg";
export { ForwardRef as ReactComponent };